import { Component } from '@angular/core';
import { BoobleModalService } from 'booble-modal';

@Component({
  selector: 'app-onboarding-success-modal',
  templateUrl: './onboarding-success-modal.component.html',
  styleUrls: ['./onboarding-success-modal.component.scss'],
})
export class OnboardingSuccessModalComponent {
  constructor(private readonly modalService: BoobleModalService) {}

  closeModal() {
    this.modalService.dismiss(null);
  }
}
